<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <div class="acs-toolbar__field">
        <i class="fa-solid fa-search acs-toolbar__icon"></i>
        <input type="text" class="acs-input acs-toolbar__input" placeholder="Search by code or name..."
               [(ngModel)]="searchTerm" (keyup.enter)="searchCustomers()">
      </div>
      <button type="button" class="acs-action-btn" (click)="searchCustomers()">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>
    <div class="acs-flex acs-flex--center acs-gap-sm">
      <small *ngIf="customers.length > 0" class="acs-text-muted">{{customers.length}} customer(s)</small>
      <button type="button" class="acs-action-btn acs-action-btn--danger"
              [disabled]="selectedCount === 0"
              (click)="requestBulkDelete()">
        <i class="fa-solid fa-trash"></i> Delete<span *ngIf="selectedCount > 0"> ({{selectedCount}})</span>
      </button>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!hasSearched" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-user-minus"></i>
      Search by code or name to find customers
    </div>
  </div>

  <div *ngIf="hasSearched" class="acs-table-wrap acs-table-wrap--connected acs-table--contained">
    <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
      <thead class="acs-thead--primary acs-sticky">
        <tr>
          <th class="acs-table__checkbox-col">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="allVisibleSelected && customers.length > 0"
                   (change)="toggleSelectAll()">
          </th>
          <th>Customer Id</th>
          <th>Cust Code</th>
          <th>Customer Name</th>
          <th>Address Line 1</th>
          <th>City</th>
          <th>Province</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of customers">
          <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
            <input type="checkbox" class="acs-table__checkbox"
                   [checked]="isSelected(c.customerId)"
                   (change)="toggleSelect(c.customerId, $event)">
          </td>
          <td>{{c.customerId}}</td>
          <td>{{c.customerCode}}</td>
          <td>{{c.customerName}}</td>
          <td>{{c.addressLine1}}</td>
          <td>{{c.city}}</td>
          <td>{{c.province}}</td>
        </tr>
        <tr *ngIf="customers.length === 0">
          <td colspan="7" class="acs-text-center acs-text-muted">No customers found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Bulk Delete Confirmation Dialog -->
<div *ngIf="showBulkDeleteConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="cancelBulkDelete()" [disabled]="isBulkDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{selectedCount}}</strong> customer(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelBulkDelete()" [disabled]="isBulkDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="isBulkDeleting">
          {{isBulkDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

